module.exports = __webpack_public_path__ + "img/IMG_5917.da05f71e.jpg";